import { Faq } from './../../models/Faq';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  private apiUrl = `${environment.apiUrl}/faq`;

  constructor(private http: HttpClient, private authService: AuthService) {}

  getFaqs(filter?: string): Observable<Faq[]> {
    const token = this.authService.getToken();
    const headers = token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : undefined;

    const url = filter
      ? `${this.apiUrl}?filter=${encodeURIComponent(filter)}`
      : this.apiUrl;

    return this.http.get<Faq[]>(url, { headers });
  }

  postFaqContact(mensagem: string): Observable<any> {
    const token = this.authService.getToken();
    const headers = token
      ? new HttpHeaders().set('Authorization', `Bearer ${token}`)
      : undefined;

    const body = { mensagem };

    return this.http.post(`${this.apiUrl}`, body, { headers });
  }
}
